import React, { useState } from "react";
import axios from "../api/axiosInstance";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom"; // ✅ import navigate

const AddMembershipPlan = () => {
  const navigate = useNavigate(); // ✅ initialize
  const [form, setForm] = useState({
    name: "",
    duration_months: "",
    original_price: "",
    discounted_price: "",
    save_percentage: "",
    profile_access: "",
    best_selling: "",
  });

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      await axios.post("/api/memberships/membership-plans-form/", form, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      toast.success("Membership plan added successfully!");

      // ✅ Reset form
      setForm({
        name: "",
        duration_months: "",
        original_price: "",
        discounted_price: "",
        save_percentage: "",
        profile_access: "",
        best_selling: "",
      });

      // ✅ Navigate to membership plan list
      navigate("/admin-html-secure-metro/purchase"); // <-- Replace with actual route
    } catch (error) {
      console.error("Error Response:", error.response?.data || error.message);
      toast.error(
        error.response?.data?.detail ||
          JSON.stringify(error.response?.data) ||
          "Failed to submit. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="mx-auto px-6 py-10 bg-amber-50">
      <div className="rounded-3xl p-6 md:p-10 space-y-6">
        <h2 className="text-3xl font-bold text-center text-green-700">
          📋 Add Membership Plan
        </h2>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid md:grid-cols-2 gap-4">
            {[
              {
                label: "Plan Name *",
                name: "name",
                type: "text",
                placeholder: "Enter plan name",
              },
              {
                label: "Duration (months) *",
                name: "duration_months",
                type: "text",
                placeholder: "Enter duration (e.g., 3 months)",
              },
              {
                label: "Original Price *",
                name: "original_price",
                type: "number",
                placeholder: "Enter original price",
              },
              {
                label: "Discounted Price *",
                name: "discounted_price",
                type: "number",
                placeholder: "Enter discounted price",
              },
              {
                label: "Save % *",
                name: "save_percentage",
                type: "number",
                placeholder: "Enter save percentage",
              },
              {
                label: "Profile Access *",
                name: "profile_access",
                type: "text",
                placeholder: "Enter profile access details",
              },
              {
                label: "Best Selling *",
                name: "best_selling",
                type: "text",
                placeholder: "Yes / No",
              },
            ].map((field) => (
              <div key={field.name}>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  {field.label}
                </label>
                <input
                  type={field.type}
                  name={field.name}
                  placeholder={field.placeholder}
                  value={form[field.name]}
                  onChange={handleChange}
                  className={`w-full border px-3 py-2 rounded-md ${
                    errors[field.name] ? "border-red-500" : "border-gray-300"
                  }`}
                />
                {errors[field.name] && (
                  <p className="text-sm text-red-600 mt-1">
                    {errors[field.name]}
                  </p>
                )}
              </div>
            ))}
          </div>

          <button
            type="submit"
            disabled={submitting}
            className={`w-full bg-green-600 text-white font-semibold py-2.5 rounded-md transition hover:bg-green-700 ${
              submitting ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {submitting ? "Submitting..." : "Add Plan"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddMembershipPlan;
